"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CategoryItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _react2 = _interopRequireDefault(require("react"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productListingContext = require("../product-listing-context");
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
/* VENDOR */

/* LOCAL */

const Category = /*#__PURE__*/(0, _react.styled)("button")({
  name: "Category",
  class: "pl-c7i6xg8",
  vars: {
    "c7i6xg8-8": [({
      isActive
    }) => isActive ? _intents.default.ux.navigateChosen.foregroundColor : _intents.default.ux.navigate.foregroundColor],
    "c7i6xg8-9": [({
      isActive
    }) => isActive ? _intents.default.ux.navigateChosen.backgroundColor : _intents.default.ux.navigate.backgroundColor],
    "c7i6xg8-10": [({
      isActive
    }) => isActive ? _intents.default.ux.navigateChosen.backgroundColor : _intents.default.ux.navigateHovered.backgroundColor]
  }
});
const Title = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Title",
  class: "pl-tq01dub"
});
const Flag = /*#__PURE__*/(0, _react.styled)(_tag.default)({
  name: "Flag",
  class: "pl-f62vbr7"
});

/**
 * Render the category item.
 * @module CategoryItem
 *
 * @param {object} props React props
 * @param {icon} string UX icon to render
 * @param {object} name Category name
 * @param {function} onClick Function for handling click behavior
 * @param {bool} isActive Flag delineating if catgeory is selected
 * @returns {React.ReactElement} Category item
 * @public
 */
function CategoryItem({
  id,
  _name,
  name,
  icon,
  categoryType,
  flagText,
  isActive = false,
  onClick,
  trackingCustomProperties = {}
}) {
  const categoryIcon = /*#__PURE__*/_react2.default.createElement(_patternLibraryUtils.Icon, {
    name: icon
  });
  const title = name?.Text;
  const flagLabel = flagText?.Text;
  if (!name) return null;
  return /*#__PURE__*/_react2.default.createElement(Category, (0, _extends2.default)({
    id: `id-${id}`,
    "data-cy": isActive ? 'active-category-item' : 'category-item',
    isActive: isActive,
    onClick: onClick
  }, _patternLibraryUtils.tracking.create(`category_${_name}`, true, false, trackingCustomProperties)), categoryIcon, /*#__PURE__*/_react2.default.createElement(Title, {
    "data-cy": "title-and-flag"
  }, title, categoryType === _productListingContext.categoryTypes.BUNDLE && /*#__PURE__*/_react2.default.createElement(Flag, {
    text: flagLabel,
    dataCy: "flag"
  })));
}
CategoryItem.propTypes = {
  id: _propTypes.default.string.isRequired,
  _name: _propTypes.default.string.isRequired,
  name: _propTypes.default.shape({
    Text: _propTypes.default.string
  }).isRequired,
  icon: _propTypes.default.string.isRequired,
  categoryType: _propTypes.default.string,
  flagText: _propTypes.default.string,
  isActive: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired,
  trackingCustomProperties: _propTypes.default.object
};